<template>
  <el-dialog
    title="Upload Before/After photo"
    :visible.sync="syncedVisible"
    :close-on-click-modal="false"
    width="520px"
    @close="reset"
  >
    <div class="op-upload">
      <label class="op-upload__field">
        <span>Operation *</span>
        <el-select
          v-model="form.operation_id"
          placeholder="Select operation"
          filterable
          no-data-text="No data"
          no-match-text="No match"
        >
          <el-option
            v-for="op in operations"
            :key="op.id"
            :label="op.name && op.name.en ? op.name.en : op.id"
            :value="op.id"
          />
        </el-select>
      </label>

      <label class="op-upload__field">
        <span>File *</span>
        <input type="file" accept="image/*" @change="onFile"/>
      </label>

      <label class="op-upload__field">
        <span>Year</span>
        <el-input-number v-model="form.year" :min="1900" :max="2100" :controls="false"/>
      </label>

      <label class="op-upload__field">
        <span>Patient age</span>
        <el-input-number v-model="form.patient_age" :min="0" :max="150" :controls="false"/>
      </label>

      <label class="op-upload__field">
        <span>Doctor ID</span>
        <el-input-number v-model="form.doctor_id" :min="1" :controls="false"/>
      </label>
    </div>

    <div slot="footer" class="op-upload__footer">
      <base-button type="default" @click="close">Cancel</base-button>
      <base-button type="primary" :disabled="!canSubmit || submitting" @click="submit">
        {{ submitting ? 'Uploading...' : 'Upload' }}
      </base-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex';

const emptyForm = () => ({
  operation_id: null,
  file: null,
  year: null,
  patient_age: null,
  doctor_id: null,
});

export default {
  props: {
    visible: { type: Boolean, required: true },
    clinicId: { type: Number, required: true },
    operations: { type: Array, default: () => [] },
  },
  data: () => ({
    form: emptyForm(),
    submitting: false,
  }),
  computed: {
    syncedVisible: {
      get() {
        return this.visible;
      },
      set(v) {
        this.$emit('update:visible', v);
      },
    },
    canSubmit() {
      return this.form.operation_id && this.form.file;
    },
  },
  methods: {
    ...mapActions('operationResultImages', ['upload']),
    onFile(e) {
      this.form.file = e.target.files[0] || null;
    },
    close() {
      this.syncedVisible = false;
    },
    reset() {
      this.form = emptyForm();
      this.submitting = false;
    },
    async submit() {
      if (!this.canSubmit) return;
      this.submitting = true;
      try {
        await this.upload({
          clinicId: this.clinicId,
          operationId: this.form.operation_id,
          file: this.form.file,
          year: this.form.year || undefined,
          patient_age: this.form.patient_age || undefined,
          doctor_id: this.form.doctor_id || undefined,
        });
        this.$notify({ type: 'success', message: 'Photo uploaded' });
        this.$emit('saved');
        this.close();
      } catch (e) {
        this.$notify({ type: 'danger', message: e?.response?.data?.error || 'Upload failed' });
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.op-upload {
  display: flex;
  flex-direction: column;
  gap: 14px;
  &__field {
    display: flex;
    flex-direction: column;
    gap: 4px;
    span {
      font-size: 13px;
      color: #555;
    }
  }
  &__footer {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
  }
}
</style>
